module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANoAAADcBAMAAADkaqL1AAAAG1BMVEUAAAB/rUCArEF/rUJ/rUF/rkJ/q0B/q0CArUE36G/gAAAACHRSTlMAYLBw0JBAIM8Zg1oAAACdSURBVHja7duxEUBAFABRhkBIB0YLapErQQnCK1sF5uY7IzhvG3gVbKP7hhSIRqPRaBltCTQXaynQSaPRaDQajUaj0Wg0Go1Go9FoNBqNRqPRaDQajfY8Go1Go2WaAo2NJEmSPqxdAx2lWp8C7bTXtRTopNFoNBqNRqPRaDQajUaj0Wg0Go1Go9FoNBqNRqPRaDVr3Rbo+MX7ULF2AaWg84E+bSnHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/partners/logo-7.png
// module id = pB7M
// module chunks = 3